<div class="card-container" #container>
    <div class="card-header-wrapper">
        <h3 class="card-title"> {{ customMsgService.translate('users') }} </h3>
    </div>

    <div class="card-component">
        <kendo-grid [kendoGridBinding]="gridView" kendoGridSelectBy="id" [selectedKeys]="mySelection" [pageSize]="10"
            [pageable]="true" [sortable]="true" [groupable]="true" [reorderable]="true" [resizable]="true"
            [height]="690" [columnMenu]="{ filter: true }" (filterChange)="filterChange($event)">
            <ng-template kendoGridToolbarTemplate>
                <kendo-textbox [placeholder]="customMsgService.translate('gridSearch')" kendoTextBox style="width: 230px;"
                    (valueChange)="onFilter($event)">
                </kendo-textbox>
                <kendo-grid-spacer></kendo-grid-spacer>
                <button kendoButton [hidden]="!canEdit()" [title]="customMsgService.translate('btnCriar')" icon="add"
                    (click)="open()" themeColor="primary">

                </button>
                <button kendoButton type="button" (click)="upload()" [title]="customMsgService.translate('btnImportar')"
                    icon="upload" themeColor="warning">
                </button>
                <button kendoGridExcelCommand type="button" [title]="customMsgService.translate('btnExportarExcel')"
                    icon="file-excel" themeColor="warning">
                </button>

                <button kendoGridPDFCommand icon="file-pdf" [title]="customMsgService.translate('btnExportarPDF')"
                    themeColor="warning"> </button>
            </ng-template>

                <kendo-grid-column field="nome" [title]="customMsgService.translate('name')" [width]="180">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <div class="customer-name"> {{ dataItem.nome }} </div>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="codigoDeFuncionario" [title]="customMsgService.translate('employeeCode')"
                    [width]="100">
                </kendo-grid-column>
                <kendo-grid-column field="funcao" [title]="customMsgService.translate('jobTitle')" [width]="100">
                </kendo-grid-column>
                <kendo-grid-column field="idCartao" [title]="customMsgService.translate('cardID')" [width]="100">
                </kendo-grid-column>
                <kendo-grid-column field="nomesEquipasDescricao" [title]="customMsgService.translate('teams')"
                    [width]="140">
                    <ng-template kendoGridCellTemplate let-dataItem>

                        <div class="customer-name"> {{ dataItem.nomesEquipas?.join(', ') }} </div>
                    </ng-template>
               </kendo-grid-column>

                <kendo-grid-column field="email" [title]="customMsgService.translate('email')" [width]="100">
                </kendo-grid-column>

            <kendo-grid-column title="" [width]="45">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <button kendoGridEditCommand icon="pencil" [title]="customMsgService.translate('btnEditar')"
                        [hidden]="!dataItem.canEdit" (click)="openEdit(dataItem)" [primary]="true"></button>

                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column title="" [width]="45">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <button kendoGridEditCommand icon="delete" [title]="customMsgService.translate('btnEliminar')"
                        [hidden]="!dataItem.canEdit" (click)="delete(dataItem)" themeColor="error"></button>

                </ng-template>
            </kendo-grid-column>
            <kendo-grid-pdf fileName="{{customMsgService.translate('users')}}.pdf" [allPages]="true" paperSize="A4" [landscape]="true"
                [scale]="0.6" [repeatHeaders]="true">
                <kendo-grid-pdf-margin top="2cm" left="1cm" right="1cm" bottom="2cm"></kendo-grid-pdf-margin>
                <ng-template kendoGridPDFTemplate let-pageNum="pageNum" let-totalPages="totalPages">
                    <div class="page-template">
                        <div class="header">
                            <div style="float: left">
                                {{ customMsgService.translate('users') }}
                            </div>
                        </div>
                        <div class="footer">{{ customMsgService.translate('pagina') }} {{ pageNum }} {{ customMsgService.translate('de_') }} {{ totalPages }}</div>
                    </div>
                </ng-template>
                <kendo-grid-column field="nome" [title]="customMsgService.translate('name')"></kendo-grid-column>
                <kendo-grid-column field="codigoDeFuncionario" [title]="customMsgService.translate('employeeCode')">
                </kendo-grid-column>
                <kendo-grid-column field="funcao" [title]="customMsgService.translate('jobTitle')">
                </kendo-grid-column>
                <kendo-grid-column field="nomesEquipasDescricao"
                    [title]="customMsgService.translate('teams')"></kendo-grid-column>
                <kendo-grid-column field="telemovel" [title]="customMsgService.translate('phone')">
                </kendo-grid-column>
                <kendo-grid-column field="email" [title]="customMsgService.translate('email')">
                </kendo-grid-column>
            
            </kendo-grid-pdf>
            
            <kendo-grid-excel [fetchData]="allData" fileName="{{customMsgService.translate('users')}}.xlsx">
            </kendo-grid-excel>

        </kendo-grid>
    </div>
</div>
<div kendoDialogContainer></div>